// extracted by mini-css-extract-plugin
module.exports = {"streamer":"Streamer_streamer__A6Nz1","profile":"Streamer_profile__OySvh","info":"Streamer_info__TlNOc","nick":"Streamer_nick___HfJl","id":"Streamer_id__seq6q"};